import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import { ref, computed } from 'vue';
import { useMutation } from '@vue/apollo-composable';
import { ProjectUpdateDocument } from '@/gql/graphql';
import {
  BAlert,
  BButton,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BModal,
  BSpinner,
} from 'bootstrap-vue-next';

// --- Component properties ---

export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectUpdate',
  props: {
    show: { type: Boolean },
    projectId: {},
    projectName: {},
    projectDescription: {}
  },
  emits: ['close', 'closeAndRefresh'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// --- Component emits ---
const emits = __emit;

// --- Component state ---
const projectName = ref<string>(props.projectName);
const projectDescription = ref<string>(props.projectDescription);

const show = computed<boolean>(() => {
  return props.show;
});

// --- Mutation: Rename Data Object ---
const mutationInProgress = ref<boolean>(false);
const mutationError = ref<string | null>(null);
const mutationShowSuccess = ref<boolean>(false);

const {
  mutate: executeMutation,
  onDone: onMutationDone,
  onError: onMutationError,
} = useMutation(ProjectUpdateDocument);

onMutationDone((res) => {
  mutationInProgress.value = false;
  if (res.data && res.data.projectUpdate) {
    console.debug('Project updated:', res.data.projectUpdate);
    mutationShowSuccess.value = true;
    setTimeout(() => {
      mutationShowSuccess.value = false;
      emits('closeAndRefresh');
    }, 1000);
  } else {
    mutationError.value = 'Project update failed: ' + res.data;
    console.error('Project update failed:', res.data);
  }
});
onMutationError((err) => {
  console.error('Error updating project:', err);
  mutationInProgress.value = false;
  mutationError.value = err.message;
});

// --- Handle component actions ---
function onProjectUpdateConfirmed() {
  if (!projectName.value) {
    mutationError.value = 'You must provide project name';
    console.error('Project name not provided');
    return;
  }
  console.debug('Updating project:', projectName.value);

  mutationInProgress.value = true;
  mutationError.value = null;
  executeMutation({
    id: props.projectId,
    name: projectName.value,
    description: projectDescription.value,
  });
}

function handleCloseModal() {
  emits('close');
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(BModal), {
      modelValue: show.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((show).value = $event)),
      onHide: handleCloseModal
    }, {
      title: _withCtx(() => [
        _createVNode(_component_font_awesome_icon, {
          icon: "pencil",
          class: "me-2"
        }),
        _cache[5] || (_cache[5] = _createTextVNode(" Update Project Details ", -1))
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(BButton), {
          variant: "secondary",
          onClick: handleCloseModal
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createTextVNode(" Cancel ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_unref(BButton), {
          variant: "primary",
          onClick: onProjectUpdateConfirmed,
          disabled: mutationInProgress.value || mutationShowSuccess.value
        }, {
          default: _withCtx(() => [
            (mutationInProgress.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                  _cache[7] || (_cache[7] = _createTextVNode(" Updating Project ", -1)),
                  _createVNode(_unref(BSpinner), {
                    small: "",
                    label: ""
                  })
                ]))
              : (mutationShowSuccess.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    _cache[8] || (_cache[8] = _createTextVNode(" Project Updated ", -1)),
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fa', 'check-double'],
                      class: "me-2"
                    })
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_3, " Update Project "))
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_unref(BFormGroup), {
            label: "Project name",
            "label-for": "new-project-name",
            class: "mt-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BFormInput), {
                modelValue: projectName.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((projectName).value = $event)),
                id: "new-project-name",
                name: "new-project-name",
                placeholder: "Enter a name for the project",
                required: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_unref(BFormGroup), {
            label: "Sample description",
            "label-for": "new-sample-description",
            class: "mt-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BFormTextarea), {
                modelValue: projectDescription.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((projectDescription).value = $event)),
                id: "new-project-description",
                name: "new-project-description",
                placeholder: "A brief description of the project."
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_unref(BAlert), {
            modelValue: mutationError.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((mutationError).value = $event)),
            variant: "danger",
            dismissible: "",
            class: "mt-3",
            onDismissed: _cache[3] || (_cache[3] = ($event: any) => (mutationError.value = null))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(mutationError.value), 1)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})